import { t } from '@lingui/macro';

import { COLUMN_TYPES } from '../../../data-table/DataTableColumns';
import { FORMATTER_TYPES } from '../../../../utilities/FormattingUtilities';
import { filterId as agentFilterId } from '../../../filters/agent-filter/AgentFilter';
import { filterId as testFilterId } from '../../../filters/test-filter/TestFilter';
import { getWirelessInterfaceColumn } from './WirelessInterfaceColumn';

export function getDefaultColumns(filterState) {
    return [
        {
            title: t`Date/Time`,
            width: 220,
            sortable: true,
            mapping: 'testTime',
            formatter: FORMATTER_TYPES.DATETIME,
        },
        {
            type: COLUMN_TYPES.STATUS,
            title: t`Status`,
            sortable: true,
            width: 84,
            mapping: 'status',
        },
        ...getWirelessInterfaceColumn(filterState),
        {
            type: COLUMN_TYPES.DRILLINLINK,
            title: t`nPoint`,
            id: 'nPoint-agent.name',
            sortable: true,
            mapping: 'agent.name',
            width: 250,
            link: {
                target: '/agent-detail',
                mappedFilterParams: {
                    [agentFilterId]: 'agent',
                },
                excludedFilterParams: [testFilterId],
            },
        },
        {
            title: t`ISP`,
            id: 'ISP-npoint-isp',
            sortable: true,
            mapping: 'npoint-isp',
            width: 100,
        },
        {
            title: t`City`,
            id: 'City-npoint-city',
            mapping: 'npoint-city',
            csvOnly: true,
        },
        {
            title: t`Subdivision Code`,
            id: 'Subdivision Code-npoint-subcode',
            mapping: 'npoint-subcode',
            csvOnly: true,
        },
    ];
}
